export default __webpack_public_path__ + "static/media/fundo meu perfil.589d75b4.svg";